// extracted by mini-css-extract-plugin
module.exports = {"greenline":"section-slice_greenline__b7LT5"};